import types from "../actionTypes";

export default (
  state = {
    isLoading: false,
  },
  action
) => {
  switch (action.type) {
    case types.SET_LOADER:
      return Object.assign({}, state, {
        isLoading: action.isLoading,
      });
    default:
      return state;
  }
};
